module.exports = __webpack_public_path__ + "img/status_icon_failed.fafeb112.svg";